import React from "react";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import KnowledgeSourceService from "../../../../../services/KnowledgeSourceService";
import PageComponent from "../../../page/PageComponent";
import KnowledgeSource from "./KnowledgeSource";
import CommonUtil from "../../../../../utils/CommonUtil";
import {
  knowledgeValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import jQuery from "jquery";
class KnowledgeSourceContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.state = this.initialState(this.state);
    this.knowledgeSourceService = new KnowledgeSourceService();
  }

  initialState = state => {
    return {
      ...state,
      knowledgeSources: [],
      show: false,
      newKnowledgeSource: {},
      disabled: true
    };
  };

  componentDidUpdate() {
    if (
      !this.state.isLoading &&
      this.props.knowledgeItem &&
      this.props.knowledgeItem.id
    ) {
      if (!("knowledgeSource" in this.props.knowledgeItem)) {
        this.loadKnowledgeSource();
      }
    }
  }

  componentDidMount() {
    this.loadKnowledgeSources();
  }

  loadKnowledgeSources = () => {
    this.prepareCall(
      this.knowledgeSourceService.getEntities(
        activeFilterPageInfo,
        this.sortInfo,
        this.onKnowledgeSourcesLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeSourcesLoad = data => {
    const knowledgeSources = data._embedded.content;
    this.setState({ knowledgeSources: knowledgeSources });
  };

  loadKnowledgeSource = () => {
    this.setState({ isLoading: true });
    const url = this.props.knowledgeItem._links.knowledgeSources.href;
    this.prepareCall(
      this.knowledgeSourceService.getEntitiesByUrl(
        url,
        this.onKnowledgeSourceLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onKnowledgeSourceLoad = data => {
    let knowledgeSource;
    const dataContent = CommonUtil.getDataContent(data);
    if (dataContent) {
      knowledgeSource = dataContent[0];
    }
    this.props.setInitialEntityPropertyState(
      "knowledgeSource",
      knowledgeSource
    );
    this.setState({ isLoading: false, knowledgeSource });
  };

  onChange = event => {
    const knowledgeSource = event.target.value;
    this.setState({ knowledgeSource });
    this.props.onChange(event);
  };

  handleShow = () => {
    this.setState({
      show: true
    });
  };

  handleClose = () => {
    this.setState({
      show: false
    });
  };

  onSave = entity => {
    this.loadKnowledgeSources();
    const knowledgeSources = this.state.knowledgeSources;
    const newKnowledgeSource = { ...this.state.newKnowledgeSource };
    knowledgeSources.push(newKnowledgeSource);
    this.setState({
      knowledgeSources
    });
    this.onChange({
      target: {
        id: "knowledgeSource",
        value: newKnowledgeSource
      }
    });
    this.handleClose();
    //TODO - ovo je hack zbog patch-a. Ako se ne zove ta metoda, ne radi dodavanje izvora znanja kada je već izabran neki izvor znanja
    this.props.resetKnowledgeSourceOnOldItem();
  };

  onNewKnowledgeSourceChange = event => {
    const { newKnowledgeSource } = this.state;
    newKnowledgeSource[event.target.id] = event.target.value;
    const disabled = !this.validator(newKnowledgeSource);
    this.setState({ newKnowledgeSource, disabled });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.generalData);
  };

  render() {
    const maxLength = {
      name: 1024,
      uri: 2000,
      institution: 1024,
      description: 2000
    };
    return (
      <KnowledgeSource
        knowledgeSources={this.state.knowledgeSources}
        processes={this.props.processes}
        partyId={this.props.partyId}
        onChange={this.onChange}
        knowledgeSource={this.state.knowledgeSource}
        editable={this.props.editable}
        maxLength={maxLength}
        handleShow={this.handleShow}
        handleClose={this.handleClose}
        show={this.state.show}
        onSave={this.onSave}
        onNewKnowledgeSourceChange={this.onNewKnowledgeSourceChange}
        newKnowledgeSource={this.state.newKnowledgeSource}
        validationRules={validationRules.generalData}
        disabled={this.state.disabled}
      />
    );
  }
}

export default KnowledgeSourceContainer;
